<script lang="ts">
	import { Locale } from "../../../core/schema/Locale";
	import { getTenant } from "../contexts/tenantContextKey";

	const { locale } = getTenant();

	export let musicEasier1 = "";
	export let musicEasier2 = "";
	/* eslint-disable svelte/no-at-html-tags */
</script>

<section class="bg-primary text-white">
	<div class="container relative py-32">
		<div
			class="absolute -top-36 left-0 right-0 mx-auto w-full rounded-lg border-4 border-black bg-black max-md:max-w-[30rem] max-sm:max-w-[95%] sm:max-w-[30rem] md:max-w-[1029px] lg:-top-[450px]"
		>
			<div class="lg:max-h-auto relative mx-auto aspect-[1029/577] max-md:max-h-80">
				<iframe
					title="Jamujam welcome video"
					class="absolute top-0 h-full w-full rounded-md object-cover"
					src={locale === Locale.cs
						? "https://player.vimeo.com/video/585334404?badge=0&autopause=0&player_id=0&app_id=58479"
						: "https://player.vimeo.com/video/658333889?badge=0&autopause=0&player_id=0&app_id=58479"}
					width="1029"
					height="577"
					frameborder="0"
					allow="autoplay; fullscreen; picture-in-picture"
					allowfullscreen={true}
				></iframe>
			</div>
		</div>
		<div class="container">
			<div class="mx-auto max-w-[61rem] text-center max-lg:pt-44 max-md:pt-10">
				<p class="mt-4 text-sm font-semibold lg:mt-10">{@html musicEasier1}</p>
				<p class="mt-4 text-xs font-semibold lg:mt-10 lg:text-sm">{@html musicEasier2}</p>
			</div>
		</div>
	</div>
</section>
